@if(!direct) {
  <div class="pt-5">
    <ls-spinner/>
  </div>
} @else {
  <div class="col-md-12">
    <div class="d-flex justify-content-between flex-column flex-md-row mt-3">
      <ul ngbNav class="nav-tabs justify-content-between border-bottom-0" [animation]="false"
          (activeIdChange)="changeInfoTypeFilter($event)"
          [(activeId)]="infoTypeFilter">
        <li [ngbNavItem]="InformationType.DIRECT">
          <a ngbNavLink class="portail-nav-link ps-0">
            Informations en direct <span class="d-none d-md-inline">({{ direct.length }})</span>
            <span class="text-light-grey d-md-none">{{ direct.length }}</span>
          </a>
        </li>
        <li [ngbNavItem]="InformationType.PINNED">
          <a ngbNavLink class="portail-nav-link">
            Épinglées <span class="d-none d-md-inline">({{ pinned.length }})</span>
            <span class="text-light-grey d-md-none">{{ pinned.length }}</span>
          </a>
        </li>
        <li [ngbNavItem]="InformationType.HISTORY">
          <a ngbNavLink class="portail-nav-link">
            Historique <span class="d-none d-md-inline">({{ history.length }})</span>
            <span class="text-light-grey d-md-none">{{ history.length }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div>
      @if(filteredInfos.length > 0 && infoTypeFilter === InformationType.HISTORY) {
        <div class="mt-2">
          <app-search-bar (search)="search = $event" [resultsCount]="(history | search:search).length"></app-search-bar>
        </div>
      }
      @for (info of filteredInfos | search:search; track info) {
        <app-info-block [info]="info" [isFirst]="$first" [adminMode]="true"
                        (edit)="edit.emit(info)"
                        (history)="toHistory.emit(info)"
                        (publish)="publish.emit(info)"
                        (archive)="toArchive.emit(info)"></app-info-block>
      } @empty {
        <p class="text-light-grey">Aucune information à afficher</p>
      }
    </div>
  </div>
}
